<template>
  <div class="wrapper">
    <page-head title="新增名单" :btn-list="btnList" :show-back="true" @handleBtn="handleBtn">
    </page-head>
    <div class="card-box">
      <Card dis-hover :padding="20" style="position: relative">
        <i-form ref="formInline" label-position="top">
          <row :gutter="80">
            <i-col span="8">
              <FormItem label="所属社区" prop="communityId">
                <Select v-model="people.communityId" class="input" clearable>
                  <Option v-for="item in childShequ" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" >
              <FormItem label="姓名" prop="userName">
                <Input v-model="people.userName" placeholder="请输入真实姓名"/>
              </FormItem>
            </i-col>
            <i-col span="8" >
              <FormItem label="身份证号" prop="idCardNO">
                <Input v-model="people.idCardNO" placeholder="请输入身份证号" @on-blur="changeCardno" />
              </FormItem>
            </i-col>
            <i-col span="8" >
              <FormItem label="手机号" prop="phoneNO">
                <Input v-model="people.phoneNO" placeholder="请输入联系电话"/>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="现居住地址" prop="address">
                <Input v-model="people.address" placeholder="请输入小区名称-楼栋号-单元号-房间号"/>
              </FormItem>
            </i-col>
            <i-col span="8" >
              <FormItem label="性别" prop="sex">
                <Select v-model="people.sex" clearable>
                  <Option v-for="item in sex" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" >
              <FormItem label="从何处返回" prop="fromWhere">
                <Input v-model="people.fromWhere" placeholder="请输入从何处返回"/>
              </FormItem>
            </i-col>

            <i-col span="8">
              <FormItem label="返回日期" prop="returnTime">
                <DatePicker v-model="people.returnTime" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
              </FormItem>
            </i-col>
            <i-col span="8" >
              <FormItem label="有无发烧、咳嗽、感冒等症状" prop="symptom">
                <Select v-model="people.symptom" clearable>
                <Option value="有">有</Option>
                <Option value="无">无</Option>
              </Select>
              </FormItem>
            </i-col>
            <i-col span="8" >
              <FormItem label="是否是密切接触者" prop="contact">
                <Select v-model="people.contact" clearable>
                  <Option value="是">是</Option>
                  <Option value="否">否</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" >
              <FormItem label="具体排查情况" prop="checkWay">
                <Input v-model="people.checkWay" placeholder="请输入具体排查情况"/>
              </FormItem>
            </i-col>
            <i-col span="8" >
              <FormItem label="备注" prop="remark">
                <Input v-model="people.remark" placeholder="请输入备注"/>
              </FormItem>
            </i-col>
          </row>
        </i-form>
      </Card>
    </div>

  </div>
</template>

<script>
  import pageHead from '../../../components/head'
  export default {
    name: 'addLibrary',
    components: {
      pageHead
    },
    data () {
      return {
        childShequ:[],
        btnList: [{
          name: '提交',
          type: 'submit',
          loading: false,
        }],
        people: {
          userName: '',
          sex:'',
          idCardNO: '',
          phoneNO:'',
          communityId:'',
          returnTime:'',
          address:'',
          fromWhere:'',
          symptom:'无',
          contact:'否',
          checkWay:'',
          remark:'',
        },
        sex: [{label: '男', value: 1}, {label: '女', value: 0}],
      }
    },
    methods:{
      handleBtn (type) {
        if (type == 'submit') this.submit()
      },
      submit () {
        var data = JSON.parse(JSON.stringify(this.people))
        data.sex = data.sex?'男':'女'
        data.returnTime = data.returnTime?this.$util.FormatDate(data.returnTime, "yyyy-MM-dd"):''
        this.btnList[0].loading = true
        this.$post(this.urlobj.changeLibrary,data).then(res => {
          this.$Message.success('提交成功')
          this.$router.go(-1);
          this.btnList[0].loading = false
        }).catch(event => {
          this.btnList[0].loading = false
        })
      },
      getChildShequ() {
        var url = this.urlobj.getChildShequ;
        this.$get(url).then(res => {
          var list = res.rows.map(item => {
            return {
              name: item.communityName,
              id: item.communityId
            };
          });
          this.childShequ = list
        });
      },
      //根据身份证号回显性别
      changeCardno () {
        var cardno = this.people.idCardNO
        if (cardno[16]%2) {
          this.people.sex = 1
        }else {
          this.people.sex = 0
        }
      }
    },
    mounted () {
      this.getChildShequ();
    }
  }
</script>

<style lang="less" scoped>

  /deep/ .ivu-date-picker {
    display: block;
  }
  .card-box {
    margin: 0 20px 20px;
  }
</style>
